export const messages = {
  empty: {
    description: {
      id: 'admin/promotions.form.more-for-less.view.empty-description',
    },
    addItems: {
      id: 'admin/promotions.form.utils.add-items',
    },
  },
  trigger: {
    description: {
      id: 'admin/promotions.form.more-for-less.view.trigger.description',
    },
  },
  benefit: {
    description: {
      id: 'admin/promotions.form.more-for-less.view.benefit.description',
    },
    maxPrice: {
      id: 'admin/promotions.form.more-for-less.view.benefit.max-price',
    },
    percentualTitle: {
      id: 'admin/promotions.form.more-for-less.view.benefit.percentual',
    },
    advanced: {
      title: {
        id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.title',
      },
      allowedProducts: {
        id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.allowed-products',
      },
      discountDistribution: {
        id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.discount-distribution',
      },
      equals: {
        id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.equals',
      },
      mostExpensive: {
        id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.most-expensive',
      },
      distributed: {
        id: 'admin/promotions.form.more-for-less.view.benefit.advanced-config.distributed',
      },
    },
  },
}
